module.exports = {"title":"Producties","body":"<h2>Agora</h2>\n<p><a href=\"./Agora/\"><img src=\"./Agora/Agora.jpg\" ></a></p>\n<h2>Jute</h2>\n<p><a href=\"./Jute/\"><img src=\"./Jute/Jute.jpg\" ></a></p>\n<h2>Clair-Obscur</h2>\n<p><a href=\"./ClairObscur/\"><img src=\"./ClairObscur/Muzikanten.JPG\" ></a></p>\n<h2>De Madonna van de Tederheid</h2>\n<p><a href=\"./DeGeleMadonna/\"><img src=\"./DeGeleMadonna/gmk.jpg\" ></a></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./producties/index.md
// module id = 1030
// module chunks = 0